import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { useEffect } from 'react';
import { Instagram } from './Instagram';

export interface StandaloneInstagramProps extends StandaloneComponentProps<typeof Instagram> {
  instagramHtml: string;
}

export const StandaloneInstagram: StandaloneComponent<StandaloneInstagramProps> = ({ instagramHtml, ...props }) => {
  useEffect(() => {
    if (!instagramHtml) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        const scriptSrc = 'https://platform.instagram.com/en_US/embeds.js';

        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
          const script = document.createElement('script');
          script.src = scriptSrc;
          script.async = true;
          script.fetchPriority = 'low';
          script.onload = () => {
            const instgrm = window.instgrm;
            if (instgrm?.Embeds?.process) {
              requestIdleCallback(() => {
                instgrm.Embeds.process();
              });
            }
          };
          document.body.appendChild(script);
        } else {
          const instgrm = window.instgrm;
          if (instgrm?.Embeds?.process) {
            requestIdleCallback(() => {
              instgrm.Embeds.process();
            });
          }
        }
        observer.disconnect();
      },
      {
        rootMargin: `0px 0px ${Math.round(window.innerHeight * 0.2)}px 0px`,
        threshold: 0,
      },
    );

    const el = document.getElementById('instagram-embed');
    if (el) {
      observer.observe(el);
    }

    return () => {
      observer.disconnect();
    };
  }, [instagramHtml]);

  return (
    <div id="instagram-embed">
      <Instagram {...props}>{instagramHtml}</Instagram>
    </div>
  );
};
